import React, { useEffect } from "react";
import { RouteComponentProps } from "@reach/router"
import {
  Card,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';

import { useDispatch, useSelector } from "react-redux";

import { actions } from '../../services/users';



import AppPage from "../../components/AppFrame/AppPage";

import { RootState } from "../../store";
import ProfilePhotos from "./ProfilePhotos";

import BasicInfo from "./BasicInfo";
import TabPanel from "../../components/TabPanel";
import UserChats from "./UserChats/UserChats";
import UserActions from "./UserActions";
import { NumberParam, useQueryParam } from "use-query-params";
import UserMatches from "./UserMatches";
import UserSwipes from "./UserSwipes";
import UserGifts from "./UserGifts";
import UserInAppProducts from "./UserInAppProducts";
import UserTransactions from "./UserTransactions/UserTransactions";
import UserReports from "./UserReports";



interface Props extends RouteComponentProps {
  userId?: string;
}

const UserDetails: React.FC<Props> = ({ userId }) => {

  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.users);

  const [ tabIndex, setTabIndex ] = useQueryParam('tab', NumberParam);

  const handleChange = (event: any, newValue: any) => {
    setTabIndex(newValue, 'replaceIn');
  };

  useEffect(() => {
    if (!userId) {
      return;
    }

    if (!state.users[ userId ]) {
      dispatch(actions.loadUserDetails(userId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ userId ]);

  if (!userId) {
    return null;
  }

  const user = state.users[ userId ] ? state.users[ userId ] : null;





  const title = !user ? 'Loading...' : `${user.firstName} ${user.lastName}`;

  const currTab = tabIndex ?? 0;

  return (
    <AppPage title={title} loading={state.detailsLoading[ userId ]}>
      {
        !user ? null : (
          <React.Fragment>
            <Typography variant="h6">
              {user.firstName} {user.lastName}, {user.age}
            </Typography>
            <ProfilePhotos user={user} />
            <Card variant="outlined" sx={{ marginBottom: 2 }}>
              <Tabs value={currTab} onChange={handleChange} variant="scrollable">
                <Tab label="Basic Info" />
                <Tab label="Chats" />
                <Tab label="Matches" />
                <Tab label="Swipes" />
                <Tab label="Gifts" />
                <Tab label="In App Products" />
                <Tab label="Transactions" />
                <Tab label="Reports" />
                <Tab label="Actions" />
              </Tabs>
            </Card>
            <TabPanel value={currTab} index={0}>
              <BasicInfo user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={1}>
              <UserChats user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={2}>
              <UserMatches user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={3}>
              <UserSwipes user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={4}>
              <UserGifts user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={5}>
              <UserInAppProducts user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={6}>
              <UserTransactions user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={7}>
              <UserReports user={user} />
            </TabPanel>
            <TabPanel value={currTab} index={8}>
              <UserActions user={user} />
            </TabPanel>
          </React.Fragment>
        )
      }
    </AppPage>
  );
};

export default UserDetails;